import { render, staticRenderFns } from "./BudgetItemDetails.vue?vue&type=template&id=5df3430a&scoped=true&"
import script from "./BudgetItemDetails.vue?vue&type=script&lang=js&"
export * from "./BudgetItemDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5df3430a",
  null
  
)

export default component.exports